<template>
  <DBox
    :id="'cmp-dtplugins-related-contacts'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="$t('add_related_contact')"
    @add_click="addContactRelationClick"
  >
    <div class="ut-fh">
      <NTable
        class="dtplugins-related_contacts-list dbox1"
        :headers="headers"
        :items="contact_relations"
        :config="tableConfig"
        :id="'dtplugins-related_contacts_list'"
        height="170px"
        :showNoItems="false"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr>
            <td v-bind="tdcon('contact_name')">
              <span
                class="ut-link ut-text-accent5"
                @click.stop="(e) => onContactNameClick(item)"
                >{{ item["contact_name"] }}</span
              >
            </td>

            <td v-bind="tdcon('function')">
              <!-- <input
                  type="text"
                  class="ntable--textfield"
                  name="relation"
                  id="relation"
                  placeholder="function"
                  :value="item['relation']"
                  @blur="e => onTextInputBlur(e, 'relation', item)"
                /> -->
              <TextField2
                id="relation"
                class="dbox1"
                :showLabel="false"
                :value="item['relation']"
                placeholder="Function"
                @blur="(e) => onTextInputBlur(e, item)"
              />
            </td>

            <td v-bind="tdcon('phone1')">
              <span>
                <a
                  class="ut-link ut-text-primary"
                  v-if="item['phone1']"
                  :href="`tel:${item['phone1']}`"
                  >{{ item["phone1"] }}</a
                >
              </span>
            </td>
            <td v-bind="tdcon('mail')">
              <div class="dt-icon-container">
                <img
                  v-if="item['email1']"
                  src="static/icons/email/email-grey.svg"
                  class="dt-icon v5 s1"
                  @click="(e) => onMail(item)"
                  alt="Mail"
                  title="Mail"
                />
              </div>
            </td>
            <td v-bind="tdcon('close')">
              <div class="dt-icon-container">
                <img
                  src="static/icons/delete.svg"
                  class="dt-icon v5 s1"
                  @click="(e) => onDeleteRelatedContact(item)"
                  alt="Delete Related Contact"
                  title="Delete Related Contact"
                />
              </div>
            </td>
          </tr>
        </template>
      </NTable>
    </div>
  </DBox>
</template>

<script>
import { openMailWindow } from "@/utility";
import DBox from "../../dt-plugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import TextField from "@plugins/text-field/text-field";

import { createNTableConfig, createTableHeader } from "../../plugins/datatable";
import { confirmDelete } from "../confirmation/confirmation-common";
import { contactListLDTRoutes } from "../../modules/contacts/router/routes";
import { sendMailHref } from "../../utility";

export default {
  components: {
    TextField,
    NTable,
    DBox,
  },
  props: {
    contact_relations: {
      type: Array,
      required: true,
      default: () => [],
    },
    external_table: {
      type: String,
      required: true,
    },
    external_id: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      }),
    };
  },
  computed: {
    headers: function () {
      return [
        createTableHeader("name"),
        createTableHeader("function", { text: "Function" }),
        createTableHeader("phone1"),
        createTableHeader("mail", { text: false, mw: 30 }),
        createTableHeader("close", { text: false, mw: 30 }),
      ];
    },
  },
  methods: {
    onTextInputBlur: function ({ name, value }, item) {
      console.log("payload", { name, value, item });
      this.$emit("changed", { name, value, item });
    },
    onContactNameClick: function (contact) {
      console.log("CONTACT",contact)
            
      this.$router.push({
        name: contactListLDTRoutes.names.tab,
        params: {
          contact_id: contact.contact_id,
          tab: "overview",
        },
      });
      this.$emit("contact_selected", contact);
    },
    onMail: function (contact) {
      //openMailWindow(`mailto: ${contact.email1}`);

      console.log(contact,"::::::::");

      const {email1} = contact

      sendMailHref({subject:"",body:"",mails:[email1]});
    },
    addContactRelationClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_contact_relation",
          external_id: this.external_id,
          external_table: this.external_table,
        },
      });
    },
    onDeleteRelatedContact: async function (contact) {
      const confirmationResult = await confirmDelete(
        "Related Contact",
        contact.contact_name
      );
      if (confirmationResult == "OK") {
        this.$emit("delete", contact);
      }
    },

    // MARK: Methods
  },
};
</script>

<style lang="scss" scoped>
.cmp-dtplugins-related-contacts {
  .ut-fc {
    height: calc(100% - 40px);
  }
  
  .dt-ntable {
    td:nth-child(4),
    td:nth-child(5) {
      max-width: 30px;
      padding: 0px;
      img {
        width: 26px;
        height: 26px;
      }
    }
  }
}
</style>
